import React from 'react';
/* eslint-disable max-len */
export const AlertCircle = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3">
        <path
          d="M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z"
          stroke="#D92D20"
          strokeWidth="2"
        />
      </g>
      <g opacity="0.1">
        <path
          d="M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z"
          stroke="#D92D20"
          strokeWidth="2"
        />
      </g>
      <g clipPath="url(#clip0_8204_4475)">
        <path
          d="M18.9998 15.6667V19M18.9998 22.3333H19.0082M27.3332 19C27.3332 23.6024 23.6022 27.3333 18.9998 27.3333C14.3975 27.3333 10.6665 23.6024 10.6665 19C10.6665 14.3976 14.3975 10.6667 18.9998 10.6667C23.6022 10.6667 27.3332 14.3976 27.3332 19Z"
          stroke="#D92D20"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8204_4475">
          <rect width="20" height="20" fill="white" transform="translate(9 9)" />
        </clipPath>
      </defs>
    </svg>
  );
};
